import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import styled from 'styled-components';
import Image from '../../components/Image';
import Select from 'container/components/Select/Select';
import assets from 'assets';

const TemplateSelection = ({ setOpen }) => {
  const dispatch = useDispatch();

  const [update, setUpdate] = useState(false);

  const { selectedTemplate, templates, selectedImage, promptEdited } =
    useSelector(state => state.imageGeneration);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOnchange = e => {
    dispatch.imageGeneration.setSelectedTemplate(e.currentTarget.value);
  };

  useEffect(() => {
    if (update) {
      setTimeout(() => {
        setUpdate(false);
      }, 300);
    }
  }, [update]);

  useEffect(() => {
    if (!selectedTemplate) {
      dispatch.imageGeneration.setSelectedTemplate('Art');
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (promptEdited) {
      dispatch.imageGeneration.setSelectedTemplate('custom');
    }
    // eslint-disable-next-line
  }, [promptEdited]);

  return (
    <Container>
      <Row>
        <p className='font-size-16'>Starter prompts</p>
        <div className='close-btn' role='button' onClick={handleClose}>
          <img src={assets.closeIcon} alt='' />
        </div>
      </Row>
      <TemplateSelector>
        <Select
          promptEdited={promptEdited}
          onChange={handleOnchange}
          value={selectedTemplate}
          options={[
            ...Object.keys(templates).map(key => ({
              value: key,
              label: key,
            })),
            promptEdited ? { value: 'custom', label: 'Custom Prompt' } : {},
          ]}
        />
      </TemplateSelector>
      <ImageContainer>
        <ImageGrid>
          {!update &&
            templates[selectedTemplate]?.map(template => (
              <Image
                src={template.example_image_url}
                selected={selectedImage?.id === template.id}
                onClick={() => {
                  dispatch.imageGeneration.setPromptEdited(false);
                  dispatch.imageGeneration.setSelectedImage(template);
                  dispatch.imageGeneration.setCustomPrompt('');
                }}
              />
            ))}
        </ImageGrid>
      </ImageContainer>
    </Container>
  );
};

export default TemplateSelection;

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(100% - 11px);
  background-color: ${({ theme }) => theme.colors.darkgrey};
  transform: translateX(calc(0% + 1px));
  padding: 15px;
  display: flex;
  flex-direction: column;
  transition: 0.6s ease;
`;

const ImageContainer = styled.div`
  flex-grow: 1;
  height: 0px;
  overflow: auto;
`;

const ImageGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
`;

const TemplateSelector = styled.div`
  margin-block: 15px 14px;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
